import { gql } from "@apollo/client";

export const GET_ESTADO_EVALUACION_BY_ID = gql`
query evaluacionById($idEvaluacion: Int!) {
    evaluacionById(idEvaluacion: $idEvaluacion) {
        evaluacion{
            idEstadoEvaluacionNavigation{
                descripcion
            }
        }
    }
}`;